import { Row } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { Checkbox } from '@savgroup-front-common/core/atoms/checkbox';
import { H2 } from '@savgroup-front-common/core/atoms/headings';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const UnlinkTitleH2 = styled(H2)<{ heading: boolean }>`
  padding-top: 0;
  padding-bottom: 0;
  ${fontStyle('xl')};
  font-weight: ${fontWeight('medium')};
  line-height: 28px;
`;

export const CheckBoxPlacement = styled(Checkbox)<{
  label: string;
  name: string;
}>`
  margin: ${spacing('xxl')} 0 ${spacing('xxl')} auto;
  color: ${({ theme }) => theme.colors.headingTextColor};
`;

export const RowButtonContainer = styled(Row)`
  margin-top: ${spacing('lg')};
`;

export const UnlinkWrapper = styled(Row)`
  margin-bottom: ${spacing('lg')};
  align-items: center;
`;
